module.exports = __webpack_public_path__ + "img/checkmark_green_disabled.4819d034.svg";